import React from 'react';
import { Message, Button, List } from 'semantic-ui-react';

const CheckoutMessage = ({
  type,
  primaryMessage,
  secondaryMessage,
  tertiaryMessages = [],
  actionName,
  actionCallback,
}) => {
  return (
    <Message positive={type === 'positive'} negative={type === 'negative'}>
      <Message.Header>{primaryMessage}</Message.Header>
      <p>{secondaryMessage}</p>
      {!!(tertiaryMessages && tertiaryMessages.length) && (
        <List bulleted>
          {tertiaryMessages.map(msg => (
            <List.Item>{msg}</List.Item>
          ))}
        </List>
      )}
      {actionName && actionCallback && (
        <Button onClick={actionCallback} color="red">
          {actionName}
        </Button>
      )}
    </Message>
  );
};

export default CheckoutMessage;
